<template>
    <footer>
<!--        <p>© copyright Ynov 2020</p>-->
    </footer>
</template>

<script>
    export default {
        name:"Footer"
    }
</script>

<style lang="scss" scoped>

</style>